module.exports = __webpack_public_path__ + "fb71ff053909698ba016b77297fdfa8f.svg";